import { Outlet } from 'react-router';

import { ReservationProvider } from '../../hooks/reservation/context.tsx';
import { SECOND_OPINION_RESERVATION } from '../../hooks/reservation/second-opinion.ts';

export default function SecondOpinionLayout() {
  return (
    <ReservationProvider config={SECOND_OPINION_RESERVATION}>
      <Outlet />
    </ReservationProvider>
  );
}
